import { Type } from '@sinclair/typebox';
import { cartAddressSchema, cartLineSchema, shippingMethodSchemaLegacy } from "./cart/index.mjs";
import { priceMajorMinorInclOnlySchema, priceMajorMinorSchema, priceMajorMinorSimpleSchema } from "./price.mjs";
import { discountCodeSchema } from "./cart/cart.mjs";
import { taxSchema } from "./cart/tax.mjs";
const orderAddressSchema = Type.Omit(cartAddressSchema, ['isValid']);
const shoutSchema = Type.Object({
    handle: Type.Union([Type.String(), Type.Null()]),
    permission: Type.Boolean(),
});
export const atlasDataOrderSchema = Type.Object({
    shout: Type.Optional(shoutSchema),
});
export const orderSchema = Type.Object({
    id: Type.String(),
    cartId: Type.String(),
    date: Type.String(),
    paymentProvider: Type.Optional(Type.String()),
    paymentMethodId: Type.Optional(Type.String()),
    address: orderAddressSchema,
    useBillingAddress: Type.Boolean(),
    discountCodes: Type.Optional(Type.Array(discountCodeSchema)),
    shippingMethod: shippingMethodSchemaLegacy,
    billingAddress: Type.Optional(orderAddressSchema),
    lines: Type.Array(cartLineSchema),
    subTotal: priceMajorMinorSchema,
    total: priceMajorMinorSchema,
    paymentFailed: Type.Boolean(),
    paymentMethod: Type.Optional(Type.Object({
        id: Type.String(),
        name: Type.String(),
    })),
    usedGiftCards: Type.Array(Type.Object({
        code: Type.String(),
        amount: Type.Object({
            major: Type.Number(),
            minor: Type.Number(),
        }),
    })),
    fullyPaidWithGiftCards: Type.Boolean(),
    currency: Type.String(),
    bundleSavings: Type.Union([priceMajorMinorSimpleSchema, Type.Null()]),
    tax: Type.Optional(taxSchema),
    leftToPay: priceMajorMinorInclOnlySchema,
    atlasData: Type.Optional(atlasDataOrderSchema),
    totalPaidInclTax: Type.Union([priceMajorMinorSimpleSchema, Type.Number()]),
});
export const orderResponseSchema = Type.Object({
    order: orderSchema,
});
//# sourceMappingURL=order.js.map